// extracted by mini-css-extract-plugin
module.exports = {"sidebarWrapper":"Sidebar_sidebarWrapper__10byU","menuSection":"Sidebar_menuSection__1z0Ji","logoContainer":"Sidebar_logoContainer__1gudW","seeAllLink":"Sidebar_seeAllLink__3lwiS"};